import { render, staticRenderFns } from "./AttachmentsCounter.vue?vue&type=template&id=03e1eebb&scoped=true"
import script from "./AttachmentsCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentsCounter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AttachmentsCounter.vue?vue&type=style&index=0&id=03e1eebb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e1eebb",
  null
  
)

export default component.exports